const SDK_VERSION = "10.66.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
